import api from "../services/api";

import { IKit, IItemKit, ISearchRequest, ISearchResponse, IConference } from "../interfaces";
import { IProdutoListModel } from "./ProdutoRepository";
import { AxiosResponse } from "axios";

export interface IKitListModel {
    id?: string;
    status: number;
    numero: number;
    gerenteSetor: string;
    representante: string;
    revendedor: string;
    acerto: string;
    valor: number;
    estado: number;
    prorrogado: number;
    valorVendido: number;
    dataEntrega: string;
    valorRecebido: number;
    valorDebito: number;
    valorVendidoEmp: number;
    valorDif: number;
    liberacao: number;
    tipo: number;
    observacao: string;
    ficha: boolean;
    dataPreConferencia: string;
    valorCorrigido: number;    
}

interface KitInsertRequest {
    kit: IKit;
    items: IProdutoListModel[];
}

interface IKitPutModel {
    pedidoId?: string;
    revendedorId?: string;
    statusKit?: number;
    prorrogado?: number;
    estado?: number;
    tipo?: number;
    valor?: string;
    liberacao?: number;
}
interface IKitPutModelNaoLiberado{
    liberacao?: number;
}
interface IKitPutModelObs{
    observacao?: string;
}

interface IKitPutModelFicha{
    ficha?: boolean;
}

interface IKitUpdateRequest {
    id: string;
    kitPutModel: IKitPutModel;
}

interface IKitUpdateNaoLiberado {
    id: string;
    kitPutModelNaoLiberado: IKitPutModelNaoLiberado;
}

interface IKitUpdateObsRequest {
    id: string;
    kitPutModelObs: IKitPutModelObs;
}

interface IKitUpdateFichaRequest {
    id: string;
    kitPutModelFicha: IKitPutModelFicha;
}

interface IKitResponse {
    kit: IKit;
    message: string;
}

interface IKitToConferenceRequest {
    searchRequest: ISearchRequest;
    month: number;
    status: string;
}

interface IKitToConferenceUpdateRequest {
    month?: number;
    filter: string;
    gerentesetorid?: string;
}

interface IKitCheckRequest {
    id: string;
    items: IItemKit[];
    valor: number;
}

interface IKitCheckResponse {
    conference: IConference;
    message: string;
}

class KitRepository {

    public List = async (searchRequest: ISearchRequest): Promise<ISearchResponse<IKitListModel>> => {

        const response = await api.get<ISearchResponse<IKitListModel>>("kit", {
            params: {
                search: searchRequest.search,
                filter: searchRequest.filter,
                pagenumber: searchRequest.pageNumber,
                recordsbypage: searchRequest.recordsByPage
            }
        });

        return response.data;
    }

    public ListToConference = async (conferenceRequest: IKitToConferenceRequest): Promise<ISearchResponse<IKitListModel>> => {

        const { searchRequest, month, status } = conferenceRequest;

        const response = await api.get<ISearchResponse<IKitListModel>>(`kit/month/${month}`, {
            params: {
                search: searchRequest.search,
                filter: searchRequest.filter,
                pagenumber: searchRequest.pageNumber,
                recordsbypage: searchRequest.recordsByPage,
                status: status
            }
        });

        return response.data;
    }

    public ListStocked = async (): Promise<IKit[]> => {
        const response = await api.get<IKit[]>("kit/stocked");

        return response.data;
    }

    public ListConferenceToUpdate = async ({ month, filter, gerentesetorid }: IKitToConferenceUpdateRequest): Promise<IKit[]> => {
        const response = await api.get<IKit[]>(`kit/conference/update`, {
            params: {
                month: month,
                filter: filter,
                gerentesetorid: gerentesetorid
            }
        });

        return response.data;
    }

    public ListByPedidoId = async (id: string): Promise<IKit[]> => {
        const response = await api.get<IKit[]>(`kit/pedido/${id}`);

        return response.data;
    }

    public GetById = async (id: string): Promise<IKit> => {
        const response = await api.get<IKit>(`kit/${id}`);

        return response.data;
    }

    public Insert = async ({ kit, items }: KitInsertRequest): Promise<IKitResponse> => {
        const responseKit = await api.post<IKitResponse>("kit", kit);

        const { id } = responseKit.data.kit;

        let itemsKit: IItemKit[] = [];

        items.map(x =>
            itemsKit.push({
                kitId: id,
                produtoId: x.id,
                quantidade: 1,
                valor: x.valor,
                statusItemKit: 0
            })
        );

        await api.post("itemkit", itemsKit);

        return responseKit.data;
    }

    public Update = async ({ id, kitPutModel }: IKitUpdateRequest): Promise<AxiosResponse<IKitResponse>> => {
        const response = await api.put<IKitResponse>(`kit/${id}`, kitPutModel);

        return response;
    }
    // public UpdateNaoLiberado = async ({id, kitPutModelNaoLiberado}: IKitUpdateNaoLiberado): Promise<AxiosResponse<IKitResponse>> => {
    //     const response = await api.put<IKitResponse>(`kit/${id}/naoliberado`, kitPutModelNaoLiberado);
    //     return response
    // }
    public UpdateObs = async ({id, kitPutModelObs}: IKitUpdateObsRequest): Promise<AxiosResponse<IKitResponse>> => {
        const response = await api.put<IKitResponse>(`kit/${id}/obs`, kitPutModelObs);
        return response
    }

    public UpdateFicha = async ({id, kitPutModelFicha}: IKitUpdateFichaRequest): Promise<AxiosResponse<IKitResponse>> => {
        const response = await api.put<IKitResponse>(`kit/${id}/ficha`, kitPutModelFicha);
        return response
    }

    public Check = async ({ id, items, valor }: IKitCheckRequest): Promise<IKitCheckResponse> => {
        const response = await api.post<IKitCheckResponse>(`kit/${id}/check`, {
            itemskit: items,
            valorrecebido: valor
        });

        return response.data;
    }

    public DidntReturn = async (id: string): Promise<Omit<IKitResponse, "kit">> => {
        const response = await api.post<Omit<IKitResponse, "kit">>(`kit/${id}/return`);

        return response.data;
    }
}

const kitRespository = new KitRepository();
export default kitRespository;
